import { Box, styled } from "@mui/material";

export const WeekdayPickerContainer = styled(Box)<{
  $enableTimeSelection: boolean;
}>(({ $enableTimeSelection }) => ({
  display: "flex",
  flexDirection: $enableTimeSelection ? "column" : "row",
  justifyContent: $enableTimeSelection ? "center" : "flex-start",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "20px",
  gap: $enableTimeSelection ? "24px" : "8px",
}));

export const TimeSelectionContainer = styled(Box)<{
  $enableTimeSelection: boolean;
}>(({ $enableTimeSelection, theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "24px",

  [theme.breakpoints.down("md")]: {
    flexDirection: $enableTimeSelection ? "column" : "row",
  },
}));

export const TimeDropdownContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",

  [theme.breakpoints.down(440)]: {
    flexDirection: "column",
  },
}));
